(function ($) {
  'use strict';

  this.WLCIcon = function (icon, classes) {
    if (!classes) {
      classes = [];
      if (icon && icon !== 'progress') {
        classes.push('font-icon');
      }
    }

    this.class = classes.constructor === Array ? classes.join() : classes;

    this.Version = '0.0.2';

    this.icon = icon;

    this.$svg = null;

    // Progress
    this.progressBar = {
      interval: null,
      $bar: null,
      dashVal: null,
    };

    this.generateIcon();
  };

  this.WLCIcon.prototype.generateIcon = function () {
    if (this.icon === 'progress') {
      this.setProgressType();
    } else {
      this.$svg = $(
        '<div><svg class="' +
          this.class +
          '"><use href="#' +
          this.icon +
          '" xlink:href="#' +
          this.icon +
          '"></use></svg></div>'
      );
    }
  };

  /**
   *
   * @returns {string}
   */
  this.WLCIcon.prototype.toString = function () {
    return this.$svg.html(); //because of IE11 svg bug, we need to use wrapper to get html
  };

  /**
   *
   * @returns {object} jQuery
   */
  this.WLCIcon.prototype.get = function () {
    return this.$svg;
  };

  this.WLCIcon.prototype.setProgressType = function (type) {
    if (this.icon !== 'progress') {
      console.log('You are not using a progress icon!');
      return;
    }

    if (this.$svg) {
      this.$svg.off('WLCIcon:progress:update');
    }
    if (this.progressBar.$bar) {
      this.progressBar.$bar.off(
        'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend'
      );
    }
    if (this.progressBar.interval) {
      clearInterval(this.progressBar.interval);
    }

    switch (type) {
      default:
        // Circle
        this.$svg = $(
          '<div><svg xmlns="http://www.w3.org/2000/svg" class="progress" viewBox="0 0 1000 1000">' +
            '<circle class="bar" cx="500" cy="500" r="350" stroke-width="260" transform="rotate(-90, 500, 500)" stroke-dasharray="2199.114" stroke-dashoffset="2199.114" fill="none" style="transition:stroke-dashoffset 3s cubic-bezier(0,.75,.35,1)" />' +
            '<circle class="bg" cx="500" cy="500" r="350" stroke="none" />' +
            '</svg></div>'
        );
    }

    this.progressBar.$bar = this.$svg.find('.bar');
    this.progressBar.dashVal = this.progressBar.$bar.attr('stroke-dasharray');

    if (typeof getComputedStyle === 'function') {
      this.progressBar.$bar.on(
        'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
        function () {
          if (this.progressBar.interval) {
            clearInterval(this.progressBar.interval);
          }
          this.updateValue();
        }.bind(this)
      );
    }
  };

  this.WLCIcon.prototype.updateValue = function () {
    var currentOffset = getComputedStyle(
      this.progressBar.$bar.get(0)
    ).strokeDashoffset;
    var delta =
      this.progressBar.dashVal / (this.progressBar.dashVal - currentOffset);

    this.$svg.trigger('WLCIcon:progress:update', [Math.round(100 / delta)]);
  };

  this.WLCIcon.prototype.progress = function (percentage) {
    if (this.icon !== 'progress') {
      console.log('You are not using a progress icon!');
      return;
    }

    if (typeof percentage !== 'number' || percentage < 0) {
      percentage = 0;
    } else if (percentage > 100) {
      percentage = 100;
    }

    var dashOffset = this.progressBar.dashVal * (1 - percentage / 100);
    if (
      parseFloat(this.progressBar.$bar.attr('stroke-dashoffset')) ===
      parseFloat(dashOffset)
    ) {
      return;
    }

    this.progressBar.$bar.attr('stroke-dashoffset', dashOffset);

    if (typeof getComputedStyle === 'function') {
      if (this.progressBar.interval) {
        clearInterval(this.progressBar.interval);
      }
      this.progressBar.interval = setInterval(this.updateValue.bind(this), 100);
    }
  };
}).bind(window)(jQuery);
